import React, { useEffect, useRef, useState } from "react";
import { FetchFromBackoffice, PostBackoffice } from "../../utils/request";
import { CreateTagResponse, TagList } from "../settings/types";
import CustomButton from "../../components/molecules/button";
import { TagDefenition } from "./types";
import { Tag } from "../../components/molecules/tag";
import { Tooltip } from "@mui/material";


export const MachineTags = ({ tags, serialId }: { tags: Array<TagDefenition> | undefined, serialId: string | undefined }) => {

  const [tagList, setTagList] = useState<TagList[]>([])
  const [workingTags, setWorkingTags] = useState<Array<TagDefenition>>([])
  const [newTagText, setNewTagText] = useState<string>("")
  const [openTagList, setOpenTagList] = useState<boolean>(false)

  const inputRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (inputRef.current && !inputRef.current.contains(event.target as Node)) {
        setOpenTagList(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAddMachineTag = async (listTag?: TagList) => {
    const tag = listTag?.text ?? newTagText;
    const colorCode = listTag?.colorCode ?? "#f9f6ee"

    const isAlreadyAdded = workingTags.some(machineTag => machineTag.tag.toLocaleLowerCase() === tag.toLocaleLowerCase())

    if (isAlreadyAdded) {
      return;
    }
    try {
      setWorkingTags((prev) => [...prev, { tag, colorCode }]);
      setNewTagText("");
      const res = await PostBackoffice<CreateTagResponse>("cmd/machine/tag/add", {
        id: serialId,
        tag: tag
      });

    } catch (error) {
      setWorkingTags((current) => [...current.filter((t) => t.tag.toLocaleLowerCase() !== tag.toLocaleLowerCase())])
      console.error("Could not add tag:", error);
    }
  };

  const handleRemoveMachineTag = async (tagToRemove: string) => {
    const removeTag = workingTags.find((t) => t.tag === tagToRemove)

    if (!removeTag)
      return

    try {
      setWorkingTags(prev => prev.filter(tag => tag.tag !== removeTag.tag));

      await PostBackoffice("cmd/machine/tag/remove", {
        id: serialId,
        tag: removeTag.tag,
      });

    } catch (error) {
      console.error("Could not remove tag:", error);
      setWorkingTags((current) => [...current, removeTag])
    }
  };

  const fetchTagsList = async () => {
    try {
      const allTags = await FetchFromBackoffice<TagList[]>('dashboard/tags')
      setTagList(allTags)
    } catch (error) {
      console.error('Failed to fetch tags:', error)
    }
  }

  useEffect(() => {
    if (tags) {
      setWorkingTags(tags)
    } else {
      setWorkingTags([])
    }
  }, [tags])


  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 14 }}>
      <span style={{ display: "flex", gap: 10, flexWrap: "wrap", paddingTop: 4 }}>
        {workingTags.map((tag) => (
          <Tag key={tag.tag} text={tag.tag} backgroundColor colorCode={tag.colorCode} onDelete={handleRemoveMachineTag} />
        ))}
      </span>

      {openTagList && (
        <div ref={inputRef} style={{ width: "200px", alignSelf: "flex-start", position: "relative" }}>
          {/* <TextField
            size="small"
            label={"New tag"}
            value={newTagText}
            onChange={(e) => setNewTagText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleAddMachineTag();
              }
            }}
          /> */}
          <div style={{
            cursor: "pointer",
            width: 195,
            backgroundColor: "white",
            padding: "10px 0",
            borderRadius: "0 4x 4px 0",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.13)",
            position: "absolute",
            maxHeight: 600,
            overflowY: "auto",
            zIndex: 10,
          }}>

            {tagList.map((tags) => (
              <Tooltip title={tags.text}>
                <div
                  key={tags.tagId}
                  onClick={() => handleAddMachineTag(tags)}
                  style={{
                    padding: "8px 0",
                  }}
                >
                  <Tag text={tags.text} colorCodeCircle colorCode={tags.colorCode ?? ""} />
                </div>
              </Tooltip>
            ))}
          </div>
        </div>
      )}
      <div style={{ visibility: openTagList ? "hidden" : "visible" }}>
        <CustomButton noBg onClick={() => {
          setOpenTagList(true)
          fetchTagsList()
        }}>
          {'+ Add Tag'}
        </CustomButton>
      </div>

    </div>
  )
}

